import { Link } from "react-router-dom";
import { Phone, PenTool, FileSignature, Stamp, CheckCircle2 } from "lucide-react";
import { PageHero } from "./Services";
import { SITE } from "../lib/site";
import { Reveal } from "../components/Reveal";

export default function Notary() {
  const items = [
    { t: "Titles & POAs", d: "Vehicle titles, powers of attorney, bills of sale." },
    { t: "Affidavits", d: "General affidavits, statements of fact, name affidavits." },
    { t: "Contracts", d: "Loan documents, rental agreements, business contracts." },
    { t: "Acknowledgments", d: "Signature acknowledgments for personal and business use." },
  ];
  return (
    <>
      <PageHero
        eyebrow="Notary Services"
        title={
          <>
            Certified <span className="italic text-[#C5A059]">Notary</span>
            <br /> on Bustleton Ave.
          </>
        }
        image={SITE.images.notary}
      />

      <section className="py-24 lg:py-32 bg-[#FBF9F5]" data-testid="notary-section">
        <div className="max-w-[1500px] mx-auto px-6 lg:px-10 grid lg:grid-cols-12 gap-14">
          <div className="lg:col-span-5">
            <div className="label-mini">Notary Services</div>
            <h2 className="font-serif mt-6 text-4xl md:text-5xl leading-[1.05] text-[#0A192F]">
              Two signatures. One stamp. Ninety seconds.
            </h2>
            <p className="mt-6 text-[#0A192F]/70 max-w-md leading-relaxed">
              Our commissioned notaries handle vehicle-related documents dozens of
              times a day. Bring valid photo ID and the unsigned document — we
              take it from there.
            </p>
            <div className="mt-10 flex flex-wrap gap-3">
              <a href={SITE.phoneHref} className="btn-gold" data-testid="notary-call">
                <Phone className="w-4 h-4" /> Call Ahead
              </a>
              <Link to="/contact" className="btn-ghost text-[#0A192F]" data-testid="notary-contact">
                Ask a Question
              </Link>
            </div>
          </div>

          <div className="lg:col-span-7">
            <div className="grid sm:grid-cols-2 gap-6">
              {items.map((it, i) => (
                <Reveal key={it.t} delay={i * 0.05}>
                  <div className="border border-[#0A192F]/12 p-8 bg-white h-full" data-testid={`notary-card-${i}`}>
                    <span className="text-[#C5A059] font-mono-tab text-xs">0{i + 1}</span>
                    <h3 className="font-serif text-2xl mt-4 text-[#0A192F]">{it.t}</h3>
                    <p className="mt-3 text-[#0A192F]/65 text-sm leading-relaxed">{it.d}</p>
                  </div>
                </Reveal>
              ))}
            </div>

            <div className="mt-10 border-l-2 border-[#C5A059] pl-6">
              <div className="label-mini">Please bring</div>
              <ul className="mt-4 space-y-3">
                {[
                  "Valid state-issued photo ID (driver's license or passport)",
                  "Document unsigned — signatures happen in front of the notary",
                  "All named signers present, in person",
                ].map((x) => (
                  <li key={x} className="flex items-start gap-3 text-[#0A192F]/85">
                    <CheckCircle2 className="w-5 h-5 text-[#C5A059] mt-0.5 shrink-0" />
                    <span>{x}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
